/*
 * @Author: zhaoxin
 * @Date: 2020-11-28 22:16:36
 * @Description: 按需保养类别
 */
export default [
  {value: 2, name: '3个月去一次现场'},
  {value: 3, name: '2个月去一次现场'},
  {value: 4, name: '1个月去一次现场'},
]